import React from 'react';
/**
 * @type {{(effect: React.EffectCallback, deps?: React.DependencyList): void,
 * (effect: React.EffectCallback, deps?: React.DependencyList): void}}
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
/**
 * @type {boolean}
 */

var isBrowser = typeof window !== 'undefined';
/**
 * @param element
 * @param useWindow
 * @returns {{x: number, y: number}}
 */

function getScrollPosition(_ref) {
  var element = _ref.element,
      useWindow = _ref.useWindow;
  if (!isBrowser) return {
    x: 0,
    y: 0
  };
  var target = element ? element.current : document.body;
  var position = target.getBoundingClientRect();
  return useWindow ? {
    x: window.scrollX,
    y: window.scrollY
  } : {
    x: position.left,
    y: position.top
  };
}
/**
 * Read the doc for better understanding
 * https://github.com/n8tb1t/use-scroll-position#readme
 * @param {func} effect Callback
 * @param {array} deps Dependencies that trigger a callback
 * @param {ref} element Get scroll position for certain element
 * @param {boolean} useWindow
 * @param {number} wait In Milliseconds to wait between calls
 */


function useScrollPosition(effect, deps, element, useWindow, wait) {
  var position = React.useRef(getScrollPosition({
    useWindow: useWindow
  }));
  var throttleTimeout = null;

  var callBack = function callBack() {
    var currPos = getScrollPosition({
      element: element,
      useWindow: useWindow
    });
    effect({
      prevPos: position.current,
      currPos: currPos
    });
    position.current = currPos;
    throttleTimeout = null;
  };

  useIsomorphicLayoutEffect(function () {
    if (!isBrowser) {
      return;
    }

    var handleScroll = function handleScroll() {
      if (wait) {
        if (throttleTimeout === null) {
          throttleTimeout = setTimeout(callBack, wait);
        }
      } else {
        callBack();
      }
    };

    window.addEventListener('scroll', handleScroll);
    /* eslint-disable consistent-return */

    return function () {
      window.removeEventListener('scroll', handleScroll);
      throttleTimeout && clearTimeout(throttleTimeout);
    };
  }, deps);
}

useScrollPosition.defaultProps = {
  deps: [],
  element: false,
  useWindow: false,
  wait: null
};
export default useScrollPosition;